import React, { useState, useEffect } from 'react';
import { useMenuProductCategory } from '../../../hooks/menu-product-category';
import { MenuProduct } from '../../../XV2';
import { MenuProductCard } from '../card/MenuProductCard';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import { XGrid } from '@orderx/lab/ui';

const Wrapper = styled.div`
    min-height: 70vh;
`;

interface Props {
    menuProducts: MenuProduct[];
}

export function MenuProductList({ menuProducts }: Props) {
    const PAGE_SIZE = 20;
    const { category, subCategory } = useMenuProductCategory();
    const [limit, setLimit] = useState(PAGE_SIZE);
    const totalCount = menuProducts.length;
    const productsLimit = menuProducts.slice(0, limit);

    useEffect(() => {
        setLimit(PAGE_SIZE);
    }, [category, subCategory]);

    return (
        <Wrapper>
            <InfiniteScroll
                dataLength={limit}
                next={() => setLimit((limit) => limit + PAGE_SIZE)}
                hasMore={limit < totalCount}
                loader={<></>}>
                <XGrid gap={1}>
                    {productsLimit.map((menuProduct) => (
                        <MenuProductCard menuProduct={menuProduct} key={menuProduct.productId} />
                    ))}
                </XGrid>
            </InfiniteScroll>
        </Wrapper>
    );
}
